/**
 * 采购方案相关字典
 */
import Dict from '@/utils/dict-utils'

/**
 * 预算总额
 * @property {1} 5千以下
 * @property {2} 5千至2万
 * @property {3} 2万至10万
 * @property {4} 10万以上
 */
export const purchaseApplyBudgetDict = new Dict({
  1: { value: 1, label: '5千以下', min: 0, max: 5000 },
  2: { value: 2, label: '5千至2万', min: 5000, max: 20000 },
  3: { value: 3, label: '2万至10万', min: 20000, max: 100000 },
  4: { value: 4, label: '10万以上', min: 100000 }
})

/**
 * 采购申请单状态
 */
export const purchaseApplyStatusDict = new Dict({
  EDIT: {
    value: 0,
    label: '编辑中',
    type: 'primary',
    permission: ['edit', 'delete']
  },
  SUBMITTING: {
    value: 1,
    label: '待提交',
    type: 'info',
    permission: ['detail']
  },
  PENDING: {
    value: 2,
    label: '待审核',
    type: 'warning',
    permission: ['detail']
  },
  PASSED: {
    value: 3,
    label: '申请成功',
    type: 'success',
    permission: ['detail']
  },
  FAILED: {
    value: 4,
    label: '申请失败',
    type: 'error',
    permission: ['edit', 'delete']
  }
})

/**
 * 采购品目状态
 */
export const materialStatusDict = new Dict({
  NORMAL: { value: 0, label: '正常', type: 'primary' },
  VOID: { value: 1, label: '已作废', type: 'danger' }
})

/**
 * 采购品目有无框架协议
 */
export const hasFrameworkAgreementDict = new Dict({
  YES: { value: 1, label: '有' },
  NO: { value: 0, label: '无' }
})

/**
 * 采购品目来源
 */
export const materialSourceDict = new Dict({
  PUSH: { label: 'OA推送', value: 0 },
  ADDITION: { label: '新增', value: 1 }
})

/**
 * 采购方案状态
 */
export const purchasePlanStatusDict = new Dict({
  EDIT: {
    value: 0,
    label: '编辑中',
    type: 'primary',
    permission: ['edit', 'delete']
  },
  SUBMITTING: {
    value: 1,
    label: '待提交',
    type: 'info',
    permission: ['detail']
  },
  PENDING: {
    value: 2,
    label: '待审核',
    type: 'warning',
    permission: ['detail']
  },
  WITHDRAW: {
    value: 3,
    label: '已撤回',
    type: 'primary',
    permission: ['edit', 'delete']
  },
  PASSED: {
    value: 4,
    label: '制定成功',
    type: 'success',
    permission: ['detail', 'source', 'edit']
  },
  FAILED: {
    value: 5,
    label: '审批不通过',
    type: 'danger',
    permission: ['edit', 'delete', 'detail']
  }
})

/**
 * 采购方案分配状态
 * @type {DictUtil}
 * @property {false} NO 未分配
 * @property {true} YES 已分配
 */
export const purchasePlanDistributeDict = new Dict({
  NO: { value: 0, label: '未分配', type: 'info' },
  YES: { value: 1, label: '已分配', type: 'success' }
})

/**
 * 采购类别
 * @property {1} NOT_STARTED 服务类
 * @property {2} PURCHASING 劳保用品类
 * @property {3} COMPLETED 办公家具及用品类
 * @property {4} NOT_STARTED 五金日杂类
 * @property {5} PURCHASING 管道泵阀类
 * @property {6} COMPLETED 物流器具类
 * @property {7} NOT_STARTED 生产用辅料类
 * @property {8} PURCHASING 设备备件类
 * @property {9} COMPLETED 工艺装类
 * @property {10} NOT_STARTED 油脂润滑类
 * @property {11} PURCHASING 标准件
 * @property {12} COMPLETED 非金属类
 * @property {13} COMPLETED 项目类
 */
export const purchasePlanCategoryDict = new Dict({
  1: { value: '612', label: '服务类' },
  2: { value: '611', label: '劳保用品类' },
  3: { value: '610', label: '办公家具及用品类' },
  4: { value: '609', label: '五金日杂类' },
  5: { value: '608', label: '管道泵阀类' },
  6: { value: '607', label: '物流器具类' },
  7: { value: '606', label: '生产用辅料类' },
  8: { value: '605', label: '设备备件类' },
  9: { value: '604', label: '工艺装类' },
  10: { value: '603', label: '油脂润滑类' },
  11: { value: '602', label: '标准件' },
  12: { value: '601', label: '非金属类' },
  13: { value: '501', label: '项目类' }
})

/**
 * 方案类型
 * @property {1} PROTOCOL 协议采购
 * @property {2} SINGLE 单次采购
 */
export const purchasePlanTypeDict = new Dict({
  PROTOCOL: { value: 1, label: '协议采购' },
  SINGLE: { value: 2, label: '单次采购' }
})

/**
 * 采购方式
 * @property {1} BIDDING 招标
 * @property {2} INQUIRY 询比
 * @property {3} COMPETE 竞价
 * @property {4} ORDER 定点采购
 * @type {DictUtil}
 */
export const purchasePlanMethodDict = new Dict({
  BIDDING: { value: 1, label: '招标', routerName: 'WLBidList' },
  INQUIRY: { value: 2, label: '询比', routerName: 'InquiryForm' },
  // COMPETE: { value: 3, label: '竞价' },
  ORDER: { value: 4, label: '定点采购' },
  DIRECT: { value: 5, label: '直接采购' }
})

/**
 * 供应商范围
 * @property {1} PUBLIC 公开
 * @property {2} INVITE 邀请
 */
export const purchasePlanRangeOfSupplierDict = new Dict({
  PUBLIC: { value: 1, label: '公开' },
  INVITE: { value: 2, label: '邀请' }
})

/**
 * 采购状态
 * @property {0} PUBLIC 未采购
 * @property {1} INVITE 采购中
 * @property {2} INVITE 采购完成
 */
export const purchaseStatusDict = new Dict({
  NO_PURCHASED: { value: 0, label: '未采购', type: 'info' },
  PURCHASEDING: { value: 1, label: '采购中', type: 'primary' },
  PURCHASED_END: { value: 2, label: '采购完成', type: 'success' },
  PURCHASED_CANCEL: { value: -1, label: '已作废', type: 'danger' },
  RE_PURCHASE: { value: 3, label: '重新采购', type: 'info' }
})

/**
 * 采购需求税率
 */
export const purchaseDemandUnitTaxRateDict = new Dict({
  0: { label: '13', value: '13' },
  1: { label: '5', value: '5' },
  2: { label: '0', value: '0' },
  3: { label: '1', value: '1' },
  4: { label: '16', value: '16' },
  5: { label: '9', value: '9' },
  6: { label: '6', value: '6' },
  7: { label: '3', value: '3' }
})

/**
 * 采购需求科目分配类别
 */
export const purchaseDemandSubTypeDict = new Dict({
  BLANK: { label: '空', value: '' },
  P: { label: 'P', value: 'P' },
  K: { label: 'K', value: 'K' }
})
